var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMainDefinixImgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 32,
    viewBox: "0 0 136 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "40.729%",
    x2: "109.431%",
    y2: "52.375%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E17",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "82.669%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.571%",
    y1: "58.202%",
    x2: "78.375%",
    y2: "43.936%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E3901",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "34.245%",
    y1: "90.748%",
    x2: "89.624%",
    y2: "2.406%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E17",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "74.26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF934B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h12.532v14.552H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.904 0c7.126 0 12.903 5.355 12.903 11.96 0 3.41-1.539 6.487-4.009 8.666H4.008C1.54 18.447 0 15.37 0 11.96 0 5.355 5.777 0 12.904 0z",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.266 3c-1.703.002-2.681 2.044-2.82 2.28-.304.512-.893.967-1.342.457-.206-.234-.023-.666.137-.914.27-.417-.09-.94-.597-.875-2.483.318-5.325 2.816-4.747 6.001.303 1.67 2.404 3.763 5.889 2.193 2.324-1.156 2.63-3.363 3.096-5.948.21-1.163.768-1.702 1.318-1.943.475-.208.488-.852.01-1.051a2.432 2.432 0 0 0-.936-.2h-.008z",
    id: "k"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.6%",
    y: "-17%",
    width: "127.1%",
    height: "133.9%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 0.748405403 0",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-9.3%",
    y: "-10.3%",
    width: "118.6%",
    height: "120.6%",
    filterUnits: "objectBoundingBox",
    id: "l"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.576470588 0 0 0 0 0.294117647 0 0 0 1 0",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.0993362107 0",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 14,
    cy: 14,
    r: 14
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.652 14.973c-.79.71-1.29 1.659-1.498 2.847h8.676c-.157-1.188-.591-2.137-1.303-2.847-.712-.709-1.641-1.064-2.788-1.064-1.268 0-2.297.355-3.087 1.064m9.236 4.643c-.226.222-.513.332-.86.332h-9.9c.19 1.242.742 2.244 1.654 3.006.912.763 2.028 1.144 3.348 1.144a4.97 4.97 0 0 0 1.628-.292c.565-.195 1.03-.435 1.394-.719.243-.195.53-.292.86-.292.33 0 .59.089.782.266.312.266.469.568.469.904 0 .32-.14.586-.417.798-.59.48-1.325.87-2.202 1.171-.877.302-1.715.452-2.514.452-1.424 0-2.701-.314-3.83-.944a6.774 6.774 0 0 1-2.644-2.62c-.635-1.118-.951-2.386-.951-3.805s.3-2.691.898-3.818a6.577 6.577 0 0 1 2.502-2.634c1.068-.629 2.28-.944 3.634-.944 1.338 0 2.492.302 3.465.905.973.603 1.72 1.445 2.241 2.527.521 1.082.782 2.324.782 3.725 0 .337-.114.616-.339.838M78.383 8.934c-.591.656-.886 1.526-.886 2.607v.719h2.657c.365 0 .66.106.886.319.226.213.339.496.339.851 0 .32-.113.585-.339.798-.226.213-.52.32-.886.32h-2.657v10.375c0 .408-.122.736-.365.984-.243.249-.582.373-1.016.373-.348 0-.647-.124-.899-.373-.252-.248-.378-.576-.378-.984V14.547h-1.12c-.365 0-.66-.106-.886-.319a1.051 1.051 0 0 1-.339-.798c0-.355.113-.638.34-.851.225-.213.52-.32.885-.32h1.12v-.452c0-1.259.248-2.363.743-3.312a5.384 5.384 0 0 1 2.084-2.208c.894-.523 1.915-.785 3.061-.785.382 0 .7.116.951.346.252.23.378.523.378.878s-.126.648-.378.878c-.252.23-.569.346-.95.346-.974 0-1.755.328-2.345.984M111.082 25.894c-.252-.257-.378-.58-.378-.971V13.084c0-.408.126-.736.378-.984.251-.248.568-.373.95-.373.4 0 .721.125.965.373.243.248.364.576.364.984v11.839c0 .39-.121.714-.364.971-.244.257-.565.386-.964.386-.383 0-.7-.129-.951-.386",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(117.873 11.727)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.532 13.435c0 .32-.109.585-.326.798-.217.213-.5.32-.846.32-.417 0-.73-.142-.938-.426L6.279 9.072l-3.934 5.055c-.26.284-.573.425-.938.425-.348 0-.621-.106-.82-.319a1.12 1.12 0 0 1-.3-.798c0-.355.12-.683.364-.984L4.69 7.289.39 2.102C.13 1.782 0 1.446 0 1.09 0 .789.1.532.3.319.499.106.782 0 1.146 0c.417 0 .747.15.99.452L6.41 5.667 10.24.452c.226-.301.547-.452.964-.452.347 0 .621.11.82.333.2.222.3.492.3.811 0 .39-.121.745-.364 1.064L8.025 7.45l4.142 5.055c.243.266.365.576.365.931",
    fill: "#404041",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.87 25.894c-.252-.257-.378-.58-.378-.971V13.084c0-.408.126-.736.378-.984.251-.248.569-.373.95-.373.4 0 .721.125.965.373.243.248.365.576.365.984v11.839c0 .39-.122.714-.365.971-.244.257-.565.386-.964.386-.382 0-.7-.129-.951-.386M99.387 11.633a6.692 6.692 0 0 0-6.688 6.883l-.002.235v6.412a1.29 1.29 0 0 0 1.328 1.329c.4 0 .72-.126.964-.378.243-.25.364-.567.365-.947V18.75c0-1.407.378-2.472 1.134-3.193.731-.698 1.696-1.057 2.891-1.08 1.196.023 2.16.382 2.892 1.08.756.721 1.134 1.786 1.134 3.193v6.412a1.289 1.289 0 0 0 1.329 1.329 1.29 1.29 0 0 0 1.328-1.33v-6.384a6.692 6.692 0 0 0-6.675-7.146M45.09 23.621c-2.495 0-4.523-2.071-4.523-4.617 0-2.547 2.028-4.618 4.522-4.618s4.523 2.071 4.523 4.618c0 2.546-2.03 4.617-4.523 4.617m7.064-4.007a7.449 7.449 0 0 0 0-1.212V6.785c0-.71-.563-1.285-1.258-1.285-.695 0-1.259.575-1.259 1.285v6.67a6.97 6.97 0 0 0-4.547-1.69c-3.909 0-7.089 3.247-7.089 7.239 0 3.991 3.18 7.238 7.09 7.238 3.643 0 6.652-2.82 7.044-6.436a1.32 1.32 0 0 0 .019-.192",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#413343",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.096 8.49)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#g)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.591-.452c-1.613 0-2.539.909-2.671 1.014-.288.228-.844.43-1.27.203-.195-.104-.021-.296.13-.406.255-.186-.085-.419-.565-.39-2.351.142-5.042 1.253-4.495 2.67.286.743 2.276 1.674 5.575.976 2.201-.514 2.388-1.642 3.18-2.525.199-.517 1.153-.156 1.674-.263.449-.092-.211-1.102-.664-1.19a4.627 4.627 0 0 0-.887-.09h-.007z",
    fill: "url(#h)",
    opacity: 0.695,
    mask: "url(#i)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.762 15.605a.619.619 0 0 1-.63.606.619.619 0 0 1-.632-.606c0-.334.283-.605.631-.605.349 0 .631.271.631.605M16.5 15.605a.619.619 0 0 1-.631.606.619.619 0 0 1-.631-.606c0-.334.282-.605.631-.605.349 0 .631.271.631.605",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.268 16.463c-.906 0-1.64.676-1.64 1.51h3.28c0-.834-.735-1.51-1.64-1.51",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.791 19c.617 0 1.117-.46 1.117-1.028h-2.234c0 .568.5 1.028 1.117 1.028",
    fill: "#FFAD0B"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#j)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#l)",
    xlinkHref: "#k"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainDefinixImgText);
export default __webpack_public_path__ + "static/media/logo_main_definix_img_text.11a21eec.svg";
export { ForwardRef as ReactComponent };